import { api } from "constants/RotasAPI";
import usePut from "hooks/usePut";
import { ConfigAssDigitalCondominioDTO } from "types/dto/groupsign/ConfigAssDigitalCondominioDTO";

export const usePutAtualizarConfigAssDigitalCondominio = () => {
  return usePut<ConfigAssDigitalCondominioDTO>({
    url: `${api.groupsign.configuracaoAssinaturaDigital}`,
  });
};
